import type { SizeProperty, SizePropertyInput } from '@src/types';
import { execAdmin } from '../utils';

const gql = String.raw;

interface SizePropertyGraphQL {
  id: number;
  code: string;
  display: string;
  synonyms: string[];
  family: string[];
  primaryValue?: string | null;
  primaryLabel?: string | null;
  secondaryValue?: string | null;
  secondaryLabel?: string | null;
  tertiaryValue?: string | null;
  tertiaryLabel?: string | null;
  createdAt: string;
  updatedAt: string;
}

interface CreateSizePropertyInput {
  code: string;
  display: string;
  synonyms?: string[];
  family?: string[];
  primaryValue?: string | null;
  primaryLabel?: string | null;
  secondaryValue?: string | null;
  secondaryLabel?: string | null;
  tertiaryValue?: string | null;
  tertiaryLabel?: string | null;
}

interface CreateSizePropertyResponse {
  partner: {
    createSizeProperty: SizePropertyGraphQL;
  };
}

interface CreateSizePropertyVariables {
  partnerCode: string;
  input: CreateSizePropertyInput;
}

const CREATE_SIZE_PROPERTY_MUTATION = gql`
  mutation createSizeProperty($partnerCode: String!, $input: SizePropertyInputTypeAdmin!) {
    partner(code: $partnerCode) {
      createSizeProperty(input: $input) {
        id
        code
        display
        synonyms
        family
        primaryValue
        primaryLabel
        secondaryValue
        secondaryLabel
        tertiaryValue
        tertiaryLabel
        createdAt
        updatedAt
      }
    }
  }
`;

export const createSizeProperty = async ({
  partnerCode,
  token,
  data,
}: {
  partnerCode: string;
  token: string;
  data: SizePropertyInput;
}): Promise<SizeProperty> => {
  const input: CreateSizePropertyInput = {
    code: data.code,
    display: data.display,
    synonyms: data.synonyms,
    family: data.family,
    primaryValue: data.primary_value || null,
    primaryLabel: data.primary_label || null,
    secondaryValue: data.secondary_value || null,
    secondaryLabel: data.secondary_label || null,
    tertiaryValue: data.tertiary_value || null,
    tertiaryLabel: data.tertiary_label || null,
  };

  const variables: CreateSizePropertyVariables = {
    partnerCode,
    input,
  };

  const response = await execAdmin<CreateSizePropertyVariables, CreateSizePropertyResponse>(
    CREATE_SIZE_PROPERTY_MUTATION,
    { variables }
  );

  const created = response.partner.createSizeProperty;

  // Map GraphQL camelCase to frontend snake_case
  return {
    id: created.id,
    partner_code: partnerCode,
    code: created.code,
    display: created.display,
    synonyms: created.synonyms,
    family: created.family,
    primary_value: created.primaryValue,
    primary_label: created.primaryLabel,
    secondary_value: created.secondaryValue,
    secondary_label: created.secondaryLabel,
    tertiary_value: created.tertiaryValue,
    tertiary_label: created.tertiaryLabel,
    created_at: created.createdAt,
    updated_at: created.updatedAt,
  };
};
